import { handleActions } from 'redux-actions';
import action from '../action';
import { produce } from 'immer';

const { actionTypes } = action;
const { analysis } = actionTypes;

const defaultState = {
  stockData: null,
  marketcapData: null,
  totalRevenueData: {},
  insightsData: {},
  principleData: [],
  isShowContacts: false,
  companyHistoryData: null,
  keyContactsData: {
    buyer: {
      executives: [],
    },
    target: {
      executives: [],
    },
  },
  forceUpdateIds: [],
  showUploadLEModal: false,
  showOffice: false, // for LE Subsidiaries
};

const changeDraft = ({ draft, payload = {}, dataKey }) => {
  const { id, data } = payload;

  if (!draft || !payload.id || !dataKey) {
    return;
  }

  if (!draft[dataKey]) {
    draft[dataKey] = {};
  }
  draft[dataKey][id] = data;
};

export default handleActions(
  {
    [analysis.CHANGE_STOCKCHART_DATA]: (state, action) =>
      produce(state, (draft) => {
        changeDraft({
          payload: action.payload,
          dataKey: 'stockData',
          draft,
        });
      }),
    [analysis.CHANGE_MARKETCAP_DATA]: (state, action) =>
      produce(state, (draft) => {
        changeDraft({
          payload: action.payload,
          dataKey: 'marketcapData',
          draft,
        });
      }),
    [analysis.CHANGE_TOTAL_REVENUE_DATA]: (state, action) =>
      produce(state, (draft) => {
        changeDraft({
          payload: action.payload,
          dataKey: 'totalRevenueData',
          draft,
        });
      }),

    [analysis.CHANGE_ANALYSIS_INSIGHT_DATA]: (state, action) =>
      produce(state, (draft) => {
        const { id, data, segment, category } = action.payload;

        if (id && data) {
          if (!draft.insightsData[id]) {
            draft.insightsData[id] = {};
          }
          draft.insightsData[id][`${segment}-${category}`] = data;
        }
      }),
    [analysis.SET_SHOW_KEY_CONTACTS]: (state, action) =>
      produce(state, (draft) => {
        draft.isShowContacts = action.payload;
        return draft;
      }),
    [analysis.SAVE_KEY_CONTACTS_DATA]: (state, action) =>
      produce(state, (draft) => {
        draft.keyContactsData = action.payload;
        return draft;
      }),
    [analysis.CHANGE_COMPANY_HISTORY_DATA]: (state, action) =>
      produce(state, (draft) => {
        changeDraft({
          payload: action.payload,
          dataKey: 'companyHistoryData',
          draft,
        });
      }),
    [analysis.CHANGE_FORCEUPDATE_PROJECT_IDS]: (state, action) =>
      produce(state, (draft) => {
        draft.forceUpdateIds = action.payload || [];
      }),
    [analysis.TOGGLE_LE_UPLOAD_MODAL]: (state, action) =>
      produce(state, (draft) => {
        draft.showUploadLEModal = action.payload || !draft.showUploadLEModal;
      }),
    [analysis.CHANGE_SHOULD_SHOW_OFFICE]: (state, action) =>
      produce(state, (draft) => {
        draft.showOffice = action.payload;
      }),
  },
  defaultState,
);
